jQuery(document).ready(function ($) {

    if ( $('.tabs').length ) {
        $('.tabs .tabs__item').first().addClass('tabs__item--active');
        $('.tabs-content__item').first().addClass('tabs-content__item--active');
    }

    $(document).on('click', '.tabs .tabs__item', function () {
        var id = $(this).data("id");
        $('.tabs .tabs__item').removeClass('tabs__item--active');
        $('.tabs-content__item').removeClass('tabs-content__item--active');
        $('.tabs__item[data-id="' + id + '"]').addClass('tabs__item--active');
        $('.tabs-content__item[data-id="' + id + '"]').addClass('tabs-content__item--active');
    });

    let sections = $('.tab-content__item');

    $(window).scroll(function () {
        sections.each(function () {
            let id = $(this).attr('id');
            var distance = $('#' + id + '').offset().top - 360;
            let $window = $(window);

            if ($window.scrollTop() >= distance) {
                $('.page-navigation__item').removeClass('active');
                $('.page-navigation__item[href^="#' + id + '"]').addClass('active');
            } else {
                $('.page-navigation__item[href^="#' + id + '"]').removeClass('active');
            }
        });
    });
});
